import {
  BASE_TIME_MULTIPLIER,
  CONDITION_DIVISOR,
  RANDOM_FACTOR_MIN,
  RANDOM_FACTOR_RANGE
} from '@/constants'


export function getOrdinalSuffix(num) {
  if (num === 1) return 'st'
  if (num === 2) return 'nd'
  if (num === 3) return 'rd'
  return 'th'
}

export function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export function shuffleArray(arr) {
  const result = [...arr]
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]]
  }
  return result
}

export function selectRandomItems(arr, count) {
  return shuffleArray(arr).slice(0, count)
}

export function calculateRaceTime(condition, distance) {
  const baseTime = distance * BASE_TIME_MULTIPLIER
  const conditionFactor = 1 - condition / CONDITION_DIVISOR
  const randomFactor = RANDOM_FACTOR_MIN + Math.random() * RANDOM_FACTOR_RANGE
  return Math.round(baseTime * conditionFactor * randomFactor)
}
